import React, {useContext} from 'react';
import {formatAsCurrency, formatNumber} from '../../../utils/numberUtils';
import BankAccountContext from '../../../contexts/BankAccountContext';
import SummaryContext from '../../../contexts/SummaryContext';
import ItemsContext from '../../../contexts/ItemsContext';
import SummaryInfoItem from './SummaryInfoItem';
import style from './SummaryContent.scss';

const SummaryContent = () => {
  const {isFetching: isFetchingBankAccount} = useContext(BankAccountContext);
  const {
    isFetching: isFetchingSummary,
    summary: {
      totalCashCentsReceived = 0,
      totalActiveGiftsRequested = 0,
      totalGiftsReceived = 0,
      totalCashFunds = 0,
    },
  } = useContext(SummaryContext);
  const {setPage, setSort, setFilters} = useContext(ItemsContext);

  const hasPurchasedGifts = totalGiftsReceived > 0;
  const hasCashFundContributions = totalCashCentsReceived > 0;

  const updateManageFilters = (page, sort, filters) => {
    setPage(page);
    setSort(sort);
    setFilters(filters);
  };

  return (
    <div className={style.container}>
      <SummaryInfoItem
        valueIsEnabled={totalActiveGiftsRequested > 0}
        value={formatNumber(totalActiveGiftsRequested)}
        valueLabel={`gift${totalActiveGiftsRequested === 1 ? '' : 's'} added`}
        valueLink="/manage-registry#gifts"
        valueLinkOnClick={() =>
          updateManageFilters(1, 'featured', {
            price: '',
            status: '',
            type: 'item',
          })
        }
        sub={`${formatNumber(totalGiftsReceived)} purchased`}
        subIsEnabled={hasPurchasedGifts}
        subLink="/manage-registry#gifts"
        subLinkOnClick={() =>
          updateManageFilters(1, 'featured', {
            price: '',
            status: 'purchased',
            type: 'item',
          })
        }
        isLoading={isFetchingSummary}
      />
      <SummaryInfoItem
        valueIsEnabled={totalCashFunds > 0}
        value={formatNumber(totalCashFunds)}
        valueLabel={`cash fund${totalCashFunds === 1 ? '' : 's'} added`}
        valueLink="/manage-registry#gifts"
        valueLinkOnClick={() => {
          updateManageFilters(1, 'featured', {
            price: '',
            status: '',
            type: 'cash fund',
          });
        }}
        sub={`${formatAsCurrency(
          totalCashCentsReceived / 100,
          false,
        )} contributed`}
        subIsEnabled={hasCashFundContributions}
        subLink="/manage-registry#gifts"
        subLinkOnClick={() =>
          updateManageFilters(1, 'featured', {
            price: '',
            status: '',
            type: 'cash fund',
          })
        }
        isLoading={isFetchingSummary || isFetchingBankAccount}
      />
    </div>
  );
};

export default SummaryContent;
